import { Injector, ModuleWithProviders, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from 'app/shared/shared.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient} from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// AoT requires an exported function for factories
const httpLoaderFactory = (http: HttpClient): any =>new TranslateHttpLoader(http,'../../../src/assets/i18n/en/en.json','.json');

const providers = [];

@NgModule({
  declarations: [
    AppComponent,
    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    TranslateModule.forRoot({
      loader:{
          provide: TranslateLoader,
          useFactory: httpLoaderFactory,
          deps:[HttpClient]
      }
    })
  ],
  providers: providers,
  bootstrap: [AppComponent]
})

export class AppModule {
 }

@NgModule({})
export class ZuperConnectSharedModule{
  static forRoot(): ModuleWithProviders<AppModule> {
    return {
      ngModule: AppModule,
      providers: providers
    };
  }
}
